<div class="survey">
  <div>
    <div class="survey__header">
      <img src="/assets/img/darkgrey-logo2.png" alt="Logo" />
    </div>
    <div class="survey__background"></div>
    <div class="survey__form" [ngClass]="{ finished: done }">
      <div *ngIf="done" class="survey__form--module success">
        <div *ngIf="error" class="survey__icon">
          <span class="glicon-survey-sad"></span>
        </div>
        <span *ngIf="error" class="survey__feedback">
          {{ errorText }}
        </span>
        <div *ngIf="!error" class="survey__icon">
          <span class="glicon-survey"></span>
        </div>
        <span *ngIf="!error" class="survey__feedback">
          {{ feedbackText }}
        </span>
      </div>
      <div *ngIf="!done">
        <div class="survey__form--module gap-bottom">
          <span class="survey__step">{{ step1 }}</span>
          <span class="survey__question">
            {{ question1 }}
          </span>
          <gl-radiobutton
            [options]="options"
            [value]="results.question1.value"
            (onChange)="changeFirstAnswer($event)"
          ></gl-radiobutton>
        </div>
        <div class="survey__form--module gap-bottom">
          <span class="survey__step">{{ step2 }}</span>
          <span class="survey__question">
            {{ question2 }}
          </span>
          <gl-radiobutton
            [options]="options"
            (onChange)="changeSecondAnswer($event)"
          ></gl-radiobutton>
        </div>
        <div class="survey__form--module">
          <span class="survey__step">{{ step3 }}</span>
          <span class="survey__question">
            {{ question3 }}
            <span class="subtitle">{{ selectOptions }}</span>
          </span>
          <gl-checkbox [label]="labels[0].check1" (onChange)="changeThirdAnswer('1')"></gl-checkbox>
          <gl-checkbox [label]="labels[1].check2" (onChange)="changeThirdAnswer('2')"></gl-checkbox>
          <gl-checkbox [label]="labels[2].check3" (onChange)="changeThirdAnswer('3')"></gl-checkbox>
          <gl-checkbox [label]="labels[3].check4" (onChange)="changeThirdAnswer('4')"></gl-checkbox>
          <gl-checkbox [label]="labels[4].check5" (onChange)="changeThirdAnswer('5')"></gl-checkbox>
          <gl-textarea
            [label]="labels[6].labelTextarea"
            [placeholder]="labels[7].placeholderTextarea"
            (onChange)="changeTextAnswer($event)"
          ></gl-textarea>
          <div class="survey__actions">
            <gl-button
              color-primary
              [text]="labels[5].labelButton"
              (onClick)="submit()"
            ></gl-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
